import { render, staticRenderFns } from "./WorkDetails.vue?vue&type=template&id=77bdb3aa&scoped=true"
import script from "./WorkDetails.vue?vue&type=script&lang=js"
export * from "./WorkDetails.vue?vue&type=script&lang=js"
import style0 from "./WorkDetails.vue?vue&type=style&index=0&id=77bdb3aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bdb3aa",
  null
  
)

export default component.exports